
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { AssetProvider } from './contexts/AssetContext';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import './App.css';

const theme = createTheme();
function App() {
  return (
    <ThemeProvider theme={theme}>
      <AssetProvider>
        <AppRoutes/>
      </AssetProvider>
      </ThemeProvider>
  );
}

export default App;
